import { getCurrentWorkspace } from '@modules/workspaces/stores/workspaces.thunks'
import type { Workspace } from '@modules/workspaces/workspaces.type'

import { loadInitialWorkspaceAndProjectsSequential } from './loadInitialWorkspaceAndProjectsSequential'

/**
 * Same as {@link runInitialAppDataParallelBatch} but runs graft calls one after another.
 * Avoids parallel browser WebSocket handshakes that can fail on local Docker setups.
 */
export async function runInitialAppDataSequentialBatch(
  initializeUserRegionalData: () => Promise<void>
): Promise<{ workspace: Workspace | null }> {
  await loadInitialWorkspaceAndProjectsSequential()
  await initializeUserRegionalData()
  return { workspace: getCurrentWorkspace() }
}
